class FlClearCart extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    this.bindCartRefreshEvent();
  }

  bindEvents() {
    // Find all clear cart buttons in the document
    const clearCartButtons = document.querySelectorAll('[data-clear-cart]');
    clearCartButtons.forEach(button => {
      button.addEventListener('click', this.handleClearCart.bind(this));
    });
  }

  bindCartRefreshEvent() {
    // Listen for cart:refresh events to rebind the clear cart button
    document.documentElement.addEventListener('cart:refresh', () => {
      // Small timeout to ensure DOM is updated
      setTimeout(() => {
        this.bindEvents();
      }, 100);
    });
  }

  async handleClearCart(event) {
    event.preventDefault();
    
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        // Dispatch cart:refresh event to update the cart drawer
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );
      } else {
        console.error('Error clearing cart:', response.statusText);
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }
}

customElements.define('fl-clear-cart', FlClearCart);

// Initialize the clear cart functionality
new FlClearCart();

document.addEventListener('cart:refresh', () => {
    setTimeout(() => {
        new FlClearCart();
    }, 1000);
});
document.addEventListener('cart:change', () => {
    setTimeout(() => {
        new FlClearCart();
    }, 1000);
});
